import styled, { useTheme } from 'styled-components';

import { min } from '../../../utils/breakpoints';
import { formatDate, formatHHmm, fromNow, fromUnixTime } from '../../../utils/dateUtils';
import futureInstruction from '../../../utils/futureInstruction';
import textOrPlaceholder from '../../../utils/textOrPlaceholder';
import ucFirst from '../../../utils/ucFirst';
import StyledTitle from '../../Styled/StyledTitle';

const Container = styled.div``;

const Title = styled(StyledTitle)`
  margin-bottom: 0;
`;

const Stack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Timestamp = styled.p`
  font-size: 14px;
  margin: 0;
  text-align: center;

  ${min.sm} {
    text-align: left;
    font-size: 16px;
  }
`;

const BatteryInfo = styled.div`
  border: 1px solid ${(props) => props.theme.colors.light};
  border-radius: 8px;
  padding: 10px 16px;

  ${min.sm} {
    display: flex;
    align-items: center;
  }
`;

const BatteryDetails = styled.div`
  flex: 1;
`;

const StatusText = styled.p`
  margin: 2px 0;
  font-size: 14px;
  text-align: center;

  ${min.sm} {
    text-align: left;
    font-size: 16px;
  }
`;

const RecentBatteryStatus = ({ latestRecord, lastInstruction, nextInstruction }) => {
  const lastRecordDate = fromUnixTime(latestRecord?.end_date ?? 0);
  const batteryStatusText = futureInstruction(lastInstruction?.battery_update_command);
  const nextBatteryActionText =
    (nextInstruction?.battery_update_command === 'hold'
      ? 'Consume/solar charge'
      : ucFirst(nextInstruction?.battery_update_command)) +
    ` at ${formatHHmm(fromUnixTime(nextInstruction?.target_datetime_utc ?? 0))}`;

  const theme = useTheme();

  return (
    <Container>
      <Stack>
        <Title>Most recent home battery status</Title>
        <Timestamp>
          {textOrPlaceholder(
            latestRecord?.end_date,
            `${formatDate(lastRecordDate, 'dd/MM/yy')} at ${formatHHmm(lastRecordDate)} (${fromNow(lastRecordDate)})`
          )}
        </Timestamp>
        <BatteryInfo>
          <div className={'svg-icon battery-icon'}>
            <img src={theme.icons.battery} alt="Battery" />
          </div>
          <BatteryDetails>
            <StatusText>
              Battery status:{' '}
              <strong>{textOrPlaceholder(lastInstruction?.battery_update_command, batteryStatusText)}</strong>
            </StatusText>
            <StatusText>
              Battery state of charge:{' '}
              <strong>
                {textOrPlaceholder(latestRecord?.battery_soc, `${Math.floor(latestRecord?.battery_soc)}%`)}
              </strong>
            </StatusText>
            <StatusText>
              Next battery action:{' '}
              <strong>{textOrPlaceholder(nextInstruction?.battery_update_command, nextBatteryActionText)}</strong>
            </StatusText>
          </BatteryDetails>
        </BatteryInfo>
      </Stack>
    </Container>
  );
};

export default RecentBatteryStatus;
